import React from 'react';
import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import { default as __ } from '../../utils';
import Shape from '../../components/utils/shape';
import Orientation from '../../components/utils/orientation';

function ConnectedLevelBadge(props) {
  const { shade, user } = props;
  return (
    <>
      <Orientation
        landscape={
            <div
              className=" txt-pointer "
              onClick={() => navigate('/profile', { state: { show: 'level' } })}
            >
              <Shape.Base
                vertices={user.level}
                size={100}
                fill={shade}
                filter="drop-shadow(1px 1px 2px rgba(0,0,0,.1))"
              >
                <p className="txt-center txt-l -accent">{user.level}</p>
              </Shape.Base>
                 <p className="pill-button">
                  NIVEL
                </p>
            </div>
        }
      />
    </>
  );
}

const select = state => {
  return {
    user: state.session.user,
  };
};

let LevelBadge = connect(select, null)(ConnectedLevelBadge);
export default LevelBadge;
